<section class="ourpartenrssection">
    <div class="container">
      <div class="row">
        <div class="col-md-4 partner-section">
          <div>
            <blockquote>OUR PARTNERS</blockquote>
            <h2>Value-Driven Partnerships</h2>
            <p>We at Vidhema are committed to providing our customers with the best possible experience. We believe that anything less than extraordinary is unacceptable.  Our partnerships with leading technology platforms allow us to do just that.</p>
          </div>
        </div>
        <div class="col-md-7 ">
          <div class="row partner-logo-section-row">
            <div class="col-xs-6 col-md-4 partner-logo-section">
              <div>
                <i class="icon-partners adobe-partner"></i>
              </div>
            </div>
            <div class="col-xs-6 col-md-4 partner-logo-section">
              <div>
                <i class="icon-partners shopift-partner"></i>
              </div>
            </div>
            <div class="col-xs-6 col-md-4 partner-logo-section">
              <div>
                <i class="icon-partners gc-partner"></i>
              </div>
            </div>
            <div class="col-xs-6 col-md-4 partner-logo-section">
              <div>
                <i class="icon-partners aws-partner"></i>
              </div>
            </div>
            <div class="col-xs-6 col-md-4 partner-logo-section">
              <div>
                <i class="icon-partners salesforce-partner"></i>
              </div>
            </div>
            <div class="col-xs-6 col-md-4 partner-logo-section">
              <div>
                <i class="icon-partners bigcomm-partner"></i>
              </div>
            </div>
  
            <div class="col-xs-6 col-md-4 partner-logo-section">
              <div>
                <i class="icon-partners bigcomm-openai"></i>
              </div>
            </div>
            <div class="col-xs-6 col-md-4 partner-logo-section">
              <div>
                <i class="icon-partners bigcomm-azure"></i>
              </div>
            </div>
            <div class="col-md-4 partner-logo-section">
              <div>
                <i class="icon-partners bigcomm-zoho"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>